/**
 * Show params of photo delay for vip and non-vip
 */
export function logPhotoDelayValues({ photoDelayMinutes, photoDelayVipMinutes, photoDelayTags, photoDelayTagsMinutes }) {
  console.log("Delay public's access to photos for:");
  console.log('- Non-VIP =', getValue(photoDelayMinutes));
  console.log('- VIP =', getValue(photoDelayVipMinutes));
  console.log('- Tags =', getValue(photoDelayTags));
  console.log('- TagsMin =', getValue(photoDelayTagsMinutes));

  function getValue(minutes) {
    return minutes ? `${minutes} minutes` : 'not set';
  }
}

function initSelectedEventId() {
  const keyName = 'selectedEventId';
  let localValue = normalizeValue(localStorage.getItem(keyName));

  return {
    save(eventId) {
      localValue = normalizeValue(eventId);
      localStorage.setItem(keyName, eventId);
    },
    get() {
      return localValue;
    },
  };

  function normalizeValue(value) {
    return Number(value) || null;
  }
}

export const selectedEventId = initSelectedEventId();
